module.exports = __webpack_public_path__ + "assets/img/edit.444d3d85.svg";